$(document).ready(function(){

$(document).on("click",".youtube_video_main .video_item.index_video_item",function (ev) {
    var dataSrc = $(this).attr("data-frame");
    $(this).find(".video_hide").attr("src", dataSrc);
    $(this).addClass("active");
    $(this).find(".youtube_video_thumbs").hide();
    $(this).find(".video_hide").show();
    $(this).find(".video_hide")[0].src += "?&autoplay=1&mute=1";
    ev.preventDefault();
  }
);

var swiper = new Swiper(".itg_video_slider", {navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

$("span.itg_collection_up.navmenu-depth-1").on("click", function () {
  var dropDown = $(this)
    .closest(".itg_collection_accordion")
    .find("ul.navmenu.navmenu-depth-2");
  $(this)
    .closest("ul.navmenu")
    .find("ul.navmenu.navmenu-depth-2")
    .not(dropDown)
    .slideUp();

  if ($(this).hasClass("ctm_open")) {
    $(this).removeClass("ctm_open");
  } else {
    $(this)
      .closest("ul.navmenu")
      .find(".navmenu-depth-1.ctm_open")
      .removeClass("ctm_open");
    $(this).addClass("ctm_open");
  }
  dropDown.stop(false, true).slideToggle();
});

$("span.itg_collection_up.navmenu-depth-2").on("click", function () {
  var dropDown = $(this)
    .closest(".itg_collection_accordion")
    .find("ul.navmenu.navmenu-depth-3");
  $(this)
    .closest("ul.navmenu")
    .find("ul.navmenu.navmenu-depth-3")
    .not(dropDown)
    .slideUp();

  if ($(this).hasClass("ctm_open")) {
    $(this).removeClass("ctm_open");
  } else {
    $(this)
      .closest("ul.navmenu")
      .find(".navmenu-depth-2.ctm_open")
      .removeClass("ctm_open");
    $(this).addClass("ctm_open");
  }
  dropDown.stop(false, true).slideToggle();
});

/*A js*/
if (window.matchMedia("(max-width: 1234px) and (min-width:1024px)").matches) {
  $(document).on("click", ".site-header-menu-toggle--button", function () {
    $(document).find("#site-header-nav").addClass("media_site_header");
    $(document).find("#site-mobile-nav").attr("data-open", "true");
    $(document).find(".mobile-nav-panel").attr("data-animation-state", "open");
    $(document)
      .find(".mobile-nav-overlay")
      .attr("data-animation-state", "open");
    $(document).find("#site-mobile-nav").addClass("ddddddd");
  });
  $(document).on("click", ".mobile-nav-close", function () {
    $(document).find("#site-header-nav").removeClass("media_site_header");
    $(document).find("#site-mobile-nav").attr("data-open", "false");
    $(document)
      .find(".mobile-nav-panel")
      .attr("data-animation-state", "closed");
    $(document)
      .find(".mobile-nav-overlay")
      .attr("data-animation-state", "closed");
    $(document).find("#site-mobile-nav").removeClass("ddddddd");
  });

  $(document).on(
    "click",
    "ul.navmenu.navmenu-depth-1 .navmenu-button",
    function () {
      $(this).toggleClass("navmenu-link-parent-active");
      $(this)
        .closest("ul.navmenu.navmenu-depth-1 li.navmenu-item")
        .find("ul.navmenu.navmenu-depth-2.navmenu-submenu")
        .toggleClass("toggleClass");
    }
  );
  $(document).on(
    "click",
    "ul.navmenu.navmenu-depth-2.navmenu-submenu .navmenu-button",
    function () {
      $(this).toggleClass("submenu_navmenu_active");
      $(this)
        .closest("ul.navmenu.navmenu-depth-1 li.navmenu-item")
        .find("ul.navmenu.navmenu-depth-3.navmenu-submenu")
        .toggleClass("submenutoggleClass");
    }
  );
}

$(document).on("click", ".articles_focus a", function () {
  var A = $(this).attr("id");
  $(".itg_article_product_grid ul li").each(function () {
    var B = $(this).attr("id");
    if (A == B) {
      $(this).addClass("active");
      $("html, body").animate(
        {
          scrollTop: $(".active").offset().top - 130,
        },
        1000
      );
    } else {
      $(this).removeClass("active");
    }
  });
});

$(document).on("click", "a.itg_trade_next", function () {
  let stepNumber = $(this).parent().closest(".step").data("step");
  $(".step").addClass("visually-hidden");
  stepNumber++;
  $('.step[data-step="' + stepNumber + '"]').removeClass("visually-hidden");
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    "fast"
  );
});
$("a.itg_trade_prev").click(function () {
  let stepNumber = $(this).parent().closest(".step").data("step");
  $(".step").addClass("visually-hidden");
  stepNumber--;
  $('.step[data-step="' + stepNumber + '"]').removeClass("visually-hidden");
});

$(document).on("click", ".itg_trade_accordion_icon", function () {
  var label = $(this);
  var parent = label.parent(".itg_trade_menu");
  var list = label.siblings(".itg_trade_sub_menu");

  if (parent.hasClass("is-open")) {
    list.slideUp("fast");
    $(this).removeClass("active");
    parent.removeClass("is-open");
  } else {
    list.slideDown("fast");
    $(this).addClass("active");
    parent.addClass("is-open");
  }
});



  $(document).on("click", ".itg_trade_pro_checkbox input", function () {
    
      if ($(this).is(':checked')) {
        $(this).closest('.itg_trade_pro_option').find('.itg_trade_pro_qty input').prop('disabled', false);
        $(this).closest('.itg_trade_pro_option').find('.itg_trade_pro_qty input').val(1);
      }else{
        $(this).closest('.itg_trade_pro_option').find('.itg_trade_pro_qty input').prop('disabled', true);
        $(this).closest('.itg_trade_pro_option').find('.itg_trade_pro_qty input').val('');
        $(this).closest('.itg_trade_pro_option').find('.itg_trade_pro_qty input').attr('placeholder','qty');
      }

      var thslength = 0;
      $(this).closest(".itg_trade_sub_menu").find("input").each(function(index) {
         var thslength = $(this).closest('.itg_trade_sub_menu').find('input:checked').length;
         if(thslength == 0){
           $(this).closest(".itg_trade_three").find(".thrid_count").addClass("hide");
           $(this).closest(".itg_trade_three").find(".thrid_count").text(0);
         }else{
           $(this).closest(".itg_trade_three").find(".thrid_count").removeClass("hide");
           $(this).closest(".itg_trade_three").find(".thrid_count").text(thslength);
         }
      });
    
      var trade_second_total = 0;
      $(this).closest(".itg_trade_second").find("input:checked").each(function(index) {
         trade_second_total++;
      });
      if(trade_second_total == 0){
        $(this).closest(".itg_trade_second").find(".secound_count").addClass("hide");
        $(this).closest(".itg_trade_second").find(".secound_count").text('');
      }else{
        $(this).closest(".itg_trade_second").find(".secound_count").removeClass("hide");
        $(this).closest(".itg_trade_second").find(".secound_count").text(trade_second_total);
      }
      

      var trade_first_total = 0;
      $(this).closest(".itg_trade_first").find("input:checked").each(function(index) {
         trade_first_total++;
      });
      if(trade_first_total == 0){
        $(this).closest(".itg_trade_first").find(".first_count").addClass("hide");
        $(this).closest(".itg_trade_first").find(".first_count").text('');
      }else{
        $(this).closest(".itg_trade_first").find(".first_count").removeClass("hide");
        $(this).closest(".itg_trade_first").find(".first_count").text(trade_first_total);
      }
    
       var tradetotalprice = 0;
       $(".itg_trade_pro_qty input").each(function() {
          var ths_qty = $(this).val();
          if(ths_qty != ''){
             var ths_price = parseFloat($(this).attr('data-price'));
             var finalval = ths_price * ths_qty;
             tradetotalprice += finalval;
          }
      });
      $(".itg_trade_total_price .quote-total").text(tradetotalprice);
    
  });

  $(document).on("change keyup", ".itg_trade_pro_qty input", function () {
      var tradetotalprice = 0;
       $(".itg_trade_pro_qty input").each(function() {
          var ths_qty = $(this).val();
          if(ths_qty != ''){
             var ths_price = parseFloat($(this).attr('data-price'));
             var finalval = ths_price * ths_qty;
             tradetotalprice += finalval;
          }
      });
      $(".itg_trade_total_price .quote-total").text(tradetotalprice);
  });

  
   $("#trade_in").submit(function(e) {
      e.preventDefault();
      var form_data = new FormData();
      
       var custom_quote = '';
       var spare_spools = '';
       var other_comments = '';
       var fly_rod_access = '';
       var fly_reel_access = '';
       var contactphone = '';
       var quote_total = '';
     
       var trade_products = '';
      $('.number_qty').each(function (){
           var trade_qty = $.trim($(this).val());
           if(trade_qty > 0){
             var trade_item = $.trim($(this).attr('name'));
             trade_products += trade_item+'*'+trade_qty+'|';
           }
       });

       var quote_total = $.trim($('.itg_trade_main_total_price .quote-total').text());
       var custom_quote = $.trim($('#custom_quote').val());
       var spare_spools = $.trim($('#spare_spools').val());
       var other_comments = $.trim($('#other_comments').val());
       var fly_rod_access = $.trim($("input[name='fly_rod']:checked").val());
       var fly_reel_access = $.trim($("input[name='fly_reel']:checked").val());
       if(fly_rod_access != undefined){
         var fly_rod_access_val = fly_rod_access;
       }else{
         var fly_rod_access_val = '';
       }
       if(fly_reel_access != undefined){
          var fly_reel_access_val = fly_reel_access;
       }else{
         var fly_reel_access_val = '';
       }
       var contactfname = $.trim($('#contactfname').val());
       var contactlname = $.trim($('#contactlname').val());
       var contactemail = $.trim($('#contactemail').val());
       var contactphone = $.trim($('#contactphone').val());

       form_data.append("product_list", trade_products);
       form_data.append("quote_total", quote_total);
       form_data.append("custom_quote", custom_quote);
       form_data.append("spare_spools", spare_spools);
       form_data.append("other_comments", other_comments);
       form_data.append("fly_rod_access_val", fly_rod_access_val);
       form_data.append("fly_reel_access_val", fly_reel_access_val);
       form_data.append("contactfname", contactfname);
       form_data.append("contactlname", contactlname);
       form_data.append("contactemail", contactemail);
       form_data.append("contactphone", contactphone);
       $(document).find('.itg_trade_loader').addClass('loading');
        $.ajax({
            type: 'POST',
            url: 'https://dev.shopifyexperthelp.com/app/project_app/Precisionflyandtackle/trade.php',
            data:form_data,
            contentType: false,
            cache: false,
            processData:false,
            success: function(response){
              $(document).find('.itg_trade_loader').removeClass('loading');
              $(document).find('.itg_trade_in_7').removeClass('visually-hidden');
              $(document).find('.itg_trade_in_6').addClass('visually-hidden');
            },error: function(params) {
               console.log('error');
            }
        });
   });


$('#filter_text').on('keyup', function() {
  var filter = $(this).val();
  count = 0;
  $('.itg_trade_first').each(function() {
    if ($(this).attr("data-serach").search(new RegExp(filter, "i")) < 0) {
      $(this).hide();  
    } else {
      $(this).show(); 
      count++;
    }
  });
});

  if($("body").hasClass("collection_menu") == true) {
     var collhandle = $.trim($(document).find('.itg_collection_main').attr('data-handle'));
     if(collhandle != ''){
          $('.itg_collection_menu_2').each(function() {
              var datahandle = $.trim($(this).attr('data-menuhandle'));
              if(datahandle == collhandle){
                 $(this).find('.itg_collection_up_2').addClass('ctm_open');
                 $(this).find('.itgul_3').show();
                 $(this).closest(".itg_collection_menu_1").find('.itg_collection_up_1').addClass('ctm_open');
                 $(this).closest(".itg_collection_menu_1").find('.itgul_2').show();
              }
          });
          $('.itg_collection_menu_1').each(function() {
              var datahandle = $.trim($(this).attr('data-menuhandle'));
              if(datahandle == collhandle){
                 $(this).find('.itg_collection_up_1').addClass('ctm_open');
                 $(this).find('.itgul_2').show();
              }
          });
     }
  }
  
  $(document).on("click",".itg_header .site-header-main .site-header-main-content .small-promo",function () {
      $(document).find("#tidio-chat-iframe").contents().find('#button-body').trigger("click");
  });

  $(document).on("click",".itg_blog_drower svg.icon.icon-filter",function () {
    $('.itg_blog_sidebar').addClass('driwer_on');
  });
  $(document).on("click",".itg_blog_close",function () {
    $('.itg_blog_sidebar').removeClass('driwer_on');
  });

});



// new js readmore readless

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".toggle-desc").forEach(function(btn) {
    btn.addEventListener("click", function() {
      let desc = btn.closest(".bundle-grids").querySelector(".desc-text");
      let heading = btn.querySelector(".site-footer-block-title"); // <h2> ko pakda

      if (desc.classList.contains("expanded")) {
        desc.classList.remove("expanded");
        heading.textContent = "Read More"; // sirf h2 ka text change hoga
      } else {
        desc.classList.add("expanded");
        heading.textContent = "Show Less";
      }
    });
  });
});


document.querySelectorAll('.quantity-btn').forEach(button => {
  button.addEventListener('click', function() {
    const variantId = this.getAttribute('data-variant-id');
    const quantityInput = document.getElementById('quantity_' + variantId);
    let quantity = parseInt(quantityInput.value);

    if (this.classList.contains('increase')) {
      if (quantity < parseInt(quantityInput.max)) {
        quantityInput.value = quantity + 1;
      }
    } else if (this.classList.contains('decrease')) {
      if (quantity > 0) {
        quantityInput.value = quantity - 1;
      }
    }
  });
});

function checkButtonState(bundle, atcButton) {
    let hasQuantity = false;
    bundle.querySelectorAll(".quantity-input").forEach((inp) => {
        if (parseInt(inp.value) > 0) {
            hasQuantity = true;
        }
    });

    if (hasQuantity) {
        atcButton.classList.remove("disabled");
    } else {
        atcButton.classList.add("disabled");
    }
}

document.querySelectorAll(".bundle-addtocart-div").forEach((bundle) => {
    const atcButton = bundle.querySelector("[data-product-atc]");
    function checkButtonState() {
        let hasQuantity = false;
        bundle.querySelectorAll(".quantity-input").forEach((input) => {
            if (parseInt(input.value) > 0) hasQuantity = true;
        });
        atcButton.classList.toggle("disabled", !hasQuantity);
    }
    function resetInputs() {
        bundle.querySelectorAll(".quantity-input").forEach((input) => {
            input.value = 0;
        });
        checkButtonState();
    }
    function showSuccessState() {
        atcButton.textContent = "Added to cart";
        atcButton.classList.add("added");

        setTimeout(() => {
            atcButton.textContent = "Add to cart";
            atcButton.classList.remove("added");
            checkButtonState();
        }, 20000);
    }

    function flyToCart(atcButton) {
        const cartEl = document.querySelector(".site-header-cart"); // cart icon
        if (!cartEl) return;
        const ball = document.createElement("div");
        ball.className = "fly-to-cart-ball";
        document.body.appendChild(ball);
        const start = atcButton.getBoundingClientRect();
        const end = cartEl.getBoundingClientRect();
        ball.style.left = start.left + start.width / 2 + "px";
        ball.style.top = start.top + start.height / 2 + "px";
        const deltaX = end.left + end.width / 2 - (start.left + start.width / 2);
        const deltaY = end.top + end.height / 2 - (start.top + start.height / 2);
        ball.style.transition = "transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 1s";
        requestAnimationFrame(() => {
            ball.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.5)`;
            ball.style.opacity = "0.8";
        });
        // remove after animation
        ball.addEventListener("transitionend", () => {
            ball.remove();
        });
    }
    bundle.querySelectorAll(".quantity-btn").forEach((button) => {
        button.addEventListener("click", function () {
            const variantId = this.getAttribute("data-variant-id");
            const quantityInput = document.getElementById("quantity_" + variantId);
            let quantity = parseInt(quantityInput.value);
            const maxQty = parseInt(quantityInput.max) || Infinity;
            const minQty = 0;

            if (this.classList.contains("increase")) {
                quantity = Math.min(quantity, maxQty); // increment par max limit
            } else if (this.classList.contains("decrease")) {
                quantity = Math.max(quantity, minQty); // decrement par min limit
            }

            quantityInput.value = quantity;
            checkButtonState();
        });
    });

    bundle.querySelectorAll(".quantity-input").forEach((input) => {
        input.addEventListener("input", function () {
            const maxQty = parseInt(this.max) || Infinity;
            const minQty = 0;
            let value = parseInt(this.value) || 0;

            if (value > maxQty) value = maxQty;
            if (value < minQty) value = minQty;

            this.value = value;
            checkButtonState();
        });
    });

    atcButton.addEventListener("click", function () {
        if (atcButton.classList.contains("disabled")) return;
        flyToCart(atcButton);
        const itemsToAdd = [];
        bundle.querySelectorAll(".quantity-input").forEach((input) => {
            const qty = parseInt(input.value);
            if (qty > 0) {
                const variantId = input.id.replace("quantity_", "");
                itemsToAdd.push({ id: variantId, quantity: qty });
            }
        });
        if (!itemsToAdd.length) return;
        if (typeof window.AddToCartFlyout === "function") {
            const formData = [];
            itemsToAdd.forEach((item) => {
                formData.push({ name: "id", value: item.id });
                formData.push({ name: "quantity", value: item.quantity });
            });
            new AddToCartFlyout(
                formData,
                {
                    atcButton,
                    settings: {
                        moneyFormat: window.theme.moneyFormat,
                        cartRedirection: window.theme.cartRedirection || false,
                    },
                },
                {
                    onSuccess: function () {
                        resetInputs();
                        showSuccessState();
                        if (window.CartDrawer && typeof window.CartDrawer.open === "function") {
                            window.CartDrawer.open();
                        }
                    },
                }
            );
        } else {
            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: itemsToAdd }),
            })
                .then((res) => res.json())
                .then((data) => {
                    resetInputs();
                    showSuccessState();
                    if (window.CartDrawer && typeof window.CartDrawer.open === "function") {
                        window.CartDrawer.open();
                    } else {
                        fetch("/cart.js")
                            .then((res) => res.json())
                            .then((cart) => {
                                const cartCountEl = document.querySelector(".site-header-cart--count");

                                if (cartCountEl) {
                                    cartCountEl.dataset.headerCartCount = cart.item_count;

                                    if (cart.item_count > 0) {
                                        cartCountEl.classList.add("visible");
                                    } else {
                                        cartCountEl.classList.remove("visible");
                                    }
                                }
                                document.dispatchEvent(
                                    new CustomEvent("cartcount:update", {
                                        detail: { item_count: cart.item_count },
                                    })
                                );
                            });
                    }
                })
                .catch((err) => console.error("Error:", err));
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll(".productitem--description.bundle-grids");

  products.forEach(function (parentDiv) {
    const title = parentDiv.querySelector(".product-descriptions-collection");
    const descText = parentDiv.querySelector(".desc-text");
    const toggleDesc = parentDiv.querySelector(".toggle-desc");

    function toggleContent() {
      parentDiv.classList.toggle("toggle");
      if (descText) descText.classList.toggle("toggle");
      if (toggleDesc) toggleDesc.classList.toggle("toggle");
    }

    if (title) title.addEventListener("click", toggleContent);
    if (toggleDesc) toggleDesc.addEventListener("click", toggleContent);
  });
});















